import angular from 'angular';
import fp from 'micro-fp';

export default function stringSplit() {
  return function link(input, delimiter, pos) {
    return fp.compose(angular.isNumber(pos) ? fp.prop(pos) : fp.id, fp.split(delimiter))(input);
  };
}
